import { Card, Col, Form, Input, message, Modal, Row } from "antd"
import { CustomBtn } from "../../../../components/commonComponents"
import { changePassword } from "../../../../components/action";

export const PasswordChangeModal = ({ open, close, user_id }) => {
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const savePassword = () => {
        changePassword(user_id, form.getFieldsValue()).then(() => {
            messageApi.success('პაროლი წარმატებით განახლდა');
            close(false);
        }).catch((error) => {
            messageApi.error(error?.response?.data || 'დაფიქსირდა შეცდომა');
        });
    }
    return (
        <Modal
            title='პაროლის ცვლილება'
            open={open}
            onCancel={() => { close(false) }}
            footer={[
                <CustomBtn key='submit' label='დამატება' onClick={savePassword} color='green' icon={<i className="fa-solid fa-circle-plus"></i>} colorHover='#135200' />,
                <CustomBtn key='cancel' label='გაუქმება' onClick={() => { close(false) }} color='red' icon={<i className="fa-solid fa-xmark"></i>} colorHover='#8c1a1a' />
            ]}
        >
            <Card>
                {contextHolder}
                <Form
                    layout='vertical'
                    onFinish={savePassword}
                    form={form}
                >
                    <Row>
                        <Col span={24}>
                            <Form.Item
                                label='მიმდინარე პაროლი'
                                name='password'
                                rules={[
                                    {required: true, message: 'პაროლი სავალდებულოა'},
                                    // {pattern: "^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$", message: 'პაროლი უნდა შეიცავდეს მცირე და დიდ ალოებს, ციფრებს, სიმბოლოებს და უნდა იყოს მინიმუმ 8 სიმბოლო'},
                                    {max: 16, message: 'პაროლი უნდა იყოს მაქსიმუმ 16 სიმბოლო'},
                                ]}>
                                <Input.Password />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label='ახალი პაროლი'
                                name='new_password' 
                                rules={[
                                    {required: true, message: 'პაროლი სავალდებულოა'},
                                    {pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/, message: 'პაროლი უნდა შეიცავდეს მცირე და დიდ ალოებს, ციფრებს, სიმბოლოებს და უნდა იყოს მინიმუმ 8 სიმბოლო'},
                                    {max: 16, message: 'პაროლი უნდა იყოს მაქსიმუმ 16 სიმბოლო'},
                                ]}>
                                <Input.Password />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label='გაიმეორეთ ახალი პაროლი'
                                name='confirm_password'
                                rules={[
                                    {required: true, message: 'პაროლი სავალდებულოა'},
                                    {pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/, message: 'პაროლი უნდა შეიცავდეს მცირე და დიდ ალოებს, ციფრებს, სიმბოლოებს და უნდა იყოს მინიმუმ 8 სიმბოლო'},
                                    {max: 16, message: 'პაროლი უნდა იყოს მაქსიმუმ 16 სიმბოლო'},
                                    ({getFieldValue}) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('new_password') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('პაროლები არ ემთხვევა'));
                                        },
                                    }),
                                ]}>
                                <Input.Password />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </Modal>
    )
}